import { MerkleTree } from "merkletreejs";
import { encodePacked, keccak256 } from "viem";
import { InputData, CampaignResult } from "./types";

export function computeMerkleRoot({
  input,
  week_to_campaign_mapping,
  contract_data,
}: InputData): CampaignResult {
  const hashedLeaves = input.map(({ participant, amount }) =>
    keccak256(
      encodePacked(["address", "uint256"], [participant, BigInt(amount)])
    )
  );

  const merkleTree = new MerkleTree(hashedLeaves, keccak256, {
    sort: true,
  });

  const root = merkleTree.getHexRoot();

  const fullStructure: CampaignResult = {
    root: {
      merkleRoot: root,
      totalAmount: input
        .reduce((acc, { amount }) => acc + BigInt(amount), BigInt(0))
        .toString(),
      week_to_campaign_mapping,
    },
    contract_data,
    participants_with_proofs: input.map(({ participant, amount }) => ({
      participant,
      amount,

      merkleProofs: merkleTree.getHexProof(
        keccak256(
          encodePacked(["address", "uint256"], [participant, BigInt(amount)])
        )
      ),
    })),
  };

  return fullStructure;
}
